import { IconProps } from "@chakra-ui/react";
import OutlinePersonPin from "./Iconify/OutlinePersonPin";

export default function CaminoManagerIcon(props: IconProps) {
  return <OutlinePersonPin {...props} />;
}
